import { useSession } from "@clerk/clerk-react";
import { getUnexpiredToken, useCanvasId, useUserId } from "./utils";

export const useOpenDeepLinkForEditor = () => {
  const canvasId = useCanvasId();
  const { session } = useSession();
  const userId = useUserId();

  return async (editor: string) => {
    const authToken = await getUnexpiredToken(session, {
      template: "tempo-local",
    });
    const editorToUse = editor;
    if (!editorToUse) {
      return;
    }

    // Use custom SSH server approach in Helm/Kubernetes mode
    if (import.meta.env.VITE_USE_HELM === "true") {
      window.open(
        `${editorToUse}://TempoLabs.tempo/connectToCanvas?canvasId=${canvasId}&env=${
          import.meta.env.VITE_ENVIRONMENT
        }&authToken=${authToken}&authId=${userId}&backendUrl=${
          import.meta.env.VITE_BACKEND_BASE_URL
        }`,
        "_blank"
      );
    } else {
      // Original deep link for Docker mode
      window.open(
        `${editorToUse}://TempoLabs.tempo/connectToCanvas?canvasId=${canvasId}&env=${
          import.meta.env.VITE_ENVIRONMENT
        }&authToken=${authToken}&authId=${userId}&backendUrl=${
          import.meta.env.VITE_BACKEND_BASE_URL
        }`,
        "_blank"
      );
    }
  };
};

// TODO: Only send this when the extension has connected to the canvas,
//       probably just opening some websocket connection between them.
export const notifyJumpToLine = (filePath: string, lineNumber: number) =>
  fetch(`http://localhost:2996/jump_to_line`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filePath: filePath,
      lineNumber: lineNumber,
    }),
  }).catch(() => {});
